'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { trackMicrosoftPageView } from '@/lib/analytics/microsoft-uet'

/** Re-fire page views for App Router navigations after optional-cookie pageLoad. */
export function MicrosoftUet() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const lastPathRef = useRef<string | null>(null)

  useEffect(() => {
    if (!pathname) return
    const search = searchParams?.toString()
    const fullPath = search ? `${pathname}?${search}` : pathname

    if (lastPathRef.current === null) {
      lastPathRef.current = fullPath
      return
    }
    if (lastPathRef.current === fullPath) return
    lastPathRef.current = fullPath

    trackMicrosoftPageView(fullPath)
  }, [pathname, searchParams])

  return null
}
